export default "__VITE_ASSET__e52fb955__"